<template>
  <el-container class="content-layout">
<!--    <el-header style="height: 46px" class="content-header">-->
<!--      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 16px 0;">-->
<!--        <el-breadcrumb-item class="main-breadcrumb">综合查询</el-breadcrumb-item>-->
<!--        <el-breadcrumb-item class="curr-breadcrumb">{{title}}</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
<!--    </el-header>-->
    <el-main  class="content-main" ref='contentMain'>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
  import {mapState} from 'vuex';
    export default {
      name: "content-layout",
      computed: {
        ...mapState('user', {
          accountingStandard: state => state.accountingStandard,
        }),
        title() {
          if(this.$route.meta.title === '收益及收益分配表'){
            if(this.accountingStandard === 230){
              return '盈余及盈余分配表'
            } else if (this.accountingStandard === 240){
              return '收益及收益分配表'
            }
          } else {
            return this.$route.meta.title
          }
        }
      },
      watch: {
       '$route'() {
         if(this.$refs.contentMain) {
           this.$refs.contentMain.$el.scrollTo(0, 0)
         }
       }
      }
    }
</script>

<style lang="scss" scoped>
.content-layout{
  height: 100%;
  .content-header, .content-main{
    padding: 0;
  }
  .content-header{
    .main-breadcrumb{
      font-weight: bold;
      color: #606266;
    }
    .curr-breadcrumb{
      /deep/ .el-breadcrumb__inner{
        color: #3A7DD1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/content-layout.vue